<template>
  <!-- TODO: Use re-field to get validations -->
  <re-input
    :model-value="prettyModel"
    v-bind="$attrs"
  >
    <q-popup-proxy
      ref="popupEl"
      transition-show="scale"
      transition-hide="scale"
    >
      <div class="row">
        <q-date
          v-model="modelWrapper"
          mask="x"
          first-day-of-week="1"
          @update:model-value="hidePopup"
        />

        <q-time
          v-if="showTime"
          v-model="modelWrapper"
          mask="x"
          format24h
        />
      </div>

      <div class="row items-center justify-end">
        <q-btn
          v-close-popup
          label="Clear"
          color="main"
          flat
          @click="selectedDateTime = null"
        />

        <q-btn
          v-close-popup
          label="Close"
          color="main"
          flat
        />
      </div>
    </q-popup-proxy>
  </re-input>
</template>

<script setup lang="ts">
import { computed, toRaw, unref, useTemplateRef } from 'vue'

import { useGlobals } from '@/main'

const { showTime = true } = defineProps<{
  showTime?: boolean
}>()
const { $format } = useGlobals()

const popupEl = useTemplateRef<{ hide: () => void }>('popupEl')

// Values crossing API/reactive-store boundaries can be wrapped objects at runtime.
// Keep the public TypeScript contract, but let the normalizer validate the value
// instead of Vue's constructor-based prop check.
const selectedDateTime = defineModel<string | null>({ type: null })

const normalizedDate = computed<Date | null>(() => {
  const value = toRaw(unref(selectedDateTime.value))
  if (!value)
    return null
  const parsed = new Date(value)
  return Number.isNaN(parsed.getTime()) ? null : parsed
})

function hidePopup() {
  if (!showTime) {
    popupEl.value?.hide()
  }
}

const prettyModel = computed(() => {
  if (!normalizedDate.value)
    return null

  if (showTime) {
    return $format.datetime(normalizedDate.value)
  }
  else {
    return $format.date(normalizedDate.value)
  }
})

const modelWrapper = computed({
  get() {
    if (!normalizedDate.value)
      return null

    return normalizedDate.value.getTime().toString()
  },
  set(v: string | null) {
    if (!v) {
      selectedDateTime.value = null
      return
    }

    const date = new Date(Number(v))
    selectedDateTime.value = showTime
      ? date.toISOString()
      : new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString()
  },
})
</script>
